import { ZoneHelpers } from '@diagram/helpers/ZoneHelpers';

import { ZoneValidationError, ZoneValidationErrorType, ZoneValidator } from 'models';

const checkFaultConnectionResistance: ZoneValidator['validator'] = ({ zones }) => {
    const errors: ZoneValidationError[] = [];

    zones.forEach((zone) => {
        const connectionsWithZeroResistance: string[] = [];

        zone.connections.forEach((connection) => {
            const hasResistance = connection.resistance?.nom;
            const hasWireSize = connection.wireSize;
            const hasLength = connection.length?.value;

            const canCalculateResistance = hasWireSize && hasLength;

            if (!hasResistance && !canCalculateResistance) {
                connectionsWithZeroResistance.push(connection.id);
            }
        });

        if (connectionsWithZeroResistance.length) {
            const affectedConnections = zone.connections.filter((conn) =>
                connectionsWithZeroResistance.includes(conn.id),
            );
            ZoneHelpers.warning(
                errors,
                ZoneValidationErrorType.FAULT_CONNECTION_ZERO_RESISTANCE,
                zone,
                [],
                affectedConnections,
            );
        }
    });

    return errors;
};

export { checkFaultConnectionResistance };
